import { registerComponent as e } from "../../../utilities/utils.js";
import { IDSMobileMenu as i } from "./mobile-menu-element.js";
import { IDSMobileMenuItem as m } from "./item/mobile-menu-item-element.js";
import { IDSMobileMenuAvatar as r } from "./avatar/mobile-menu-avatar-element.js";
import "../../icons/user/register.js";
import "../../icons/chevron-bold/register.js";
import "../../grid/row/register.js";
e("ids-mobile-menu", i), e("ids-mobile-menu-item", m), e("ids-mobile-menu-avatar", r);